import { render, staticRenderFns } from "./BudgetContractSerialsTable.vue?vue&type=template&id=1a05d97b&"
import script from "./BudgetContractSerialsTable.vue?vue&type=script&lang=js&"
export * from "./BudgetContractSerialsTable.vue?vue&type=script&lang=js&"
import style0 from "./BudgetContractSerialsTable.vue?vue&type=style&index=0&id=1a05d97b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports